import React, { useState } from "react";
import nocomment from "../../../assets/img/dashboard/nocomment.svg";
import useFetch from "../../../hooks/useAxios";
import PersianNumber from "../../shared/PersianNumber";
import CommentBox from "./comments/CommentBox";
const UserComments = () => {
  const [postcommentInfo, setpostcommentInfo] = useState([]);
  const [residencecommentInfo, setresidencecommentInfo] = useState([]);
  const [waitingcommentInfo, setwaitingcommentInfo] = useState([]);
  const fetchpostcomment = useFetch({
    method: "get",
    url: "api/comments/posts-comments",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setpostcommentInfo(res.data.comments);
    }
  });
  const fetchresidencecomment = useFetch({
    method: "get",
    url: "api/comments/residences-comments",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setresidencecommentInfo(res.data.comments);
    }
  });
  const fetchwaitingcomment = useFetch({
    method: "get",
    url: "api/comments/comments",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setwaitingcommentInfo(res.data.comments);
    }
  });
  const [tab, settab] = useState("blog"); //blog//residence//waiting
  return (
    <div className="UserComments">
      <div className="UserComments--tab-box">
        <button
          className={`UserComments-tab ${tab === "blog"
            ? "UserComments-tab-active"
            : ""}`}
          onClick={() => settab("blog")}
        >
          <div className="UserComments-tab-count"><PersianNumber number={postcommentInfo.length} /></div>
          <div>نظرات وبلاگ</div>
        </button>
        <button
          className={`UserComments-tab ${tab === "residence"
            ? "UserComments-tab-active"
            : ""}`}
          onClick={() => settab("residence")}
        >
          <div className="UserComments-tab-count"><PersianNumber number={residencecommentInfo.length} /></div>
          <div>نظرات اقامتگاه</div>
        </button>
        <button
          className={`UserComments-tab ${tab === "waiting"
            ? "UserComments-tab-active"
            : ""}`}
          onClick={() => settab("waiting")}
        >
          <div className="UserComments-tab-count"><PersianNumber number={waitingcommentInfo.length} /></div>
          <div>نظرات من</div>
        </button>
      </div>
      {tab === "blog"
        ? postcommentInfo.length > 0
          ? <div className="UserComments-grid-2 mt-[40px]">
              {postcommentInfo.map(i => <CommentBox info={i} />)}
            </div>
          : <div className="nocomment center-column">
              <img src={nocomment} />
              <h4>دیدگاهی تا به الان ثبت نشده است !</h4>
            </div>
        : tab === "residence"
          ? (residencecommentInfo.length === 0 ? <div className="nocomment center-column">
              <img src={nocomment} />
              <h4>دیدگاهی تا به الان ثبت نشده است !</h4>
            </div> :  <div className="UserComments-grid-2 mt-[40px]">
              {residencecommentInfo.map(i => <CommentBox info={i} />)}
            </div>)
          : tab === "waiting"
            ? (waitingcommentInfo.length === 0 ? <div className="nocomment center-column">
                <img src={nocomment} />
                <h4>دیدگاهی تا به الان ثبت نشده است !</h4>
              </div> : 
               <div className="UserComments-grid-2 mt-[40px]">
               {waitingcommentInfo.map(i => <CommentBox info={i} />)}
             </div>
              )
            : null}
    </div>
  );
};

export default UserComments;
